module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Puppy Wochenende München 2025"},"en":{"title":"Puppy Weekend Munich 2025"}}')
  delete Component.options._Ctor
}
